export default "/_next/static/images/menu_line_new-215d252eebd15fcccfdfab4969fef9c2.svg";